import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const checkRedeemServiceEnable = async () => {
  return secureGet("/api/survey/checkReedemNowServiceStatus", { service: "isZampliaSurveysClaimRewardEnable" });
};

export const checkVirtualRedeemServiceEnable = async () => {
  return secureGet("/api/survey/checkReedemNowServiceStatus", { service: "isZampliaSurveysVirtualClaimRewardEnable" });
};

export const checkReferralRedeemServiceEnable = async () => {
  return secureGet("/api/survey/checkReedemNowServiceStatus", { service: "isZampliaSurveysReferralClaimRewardEnable" });
};

export const getNeoBrands = async () => {
  return secureGet("/api/survey/getNeoCurrencyBrandsOrBalance", {});
};

type formState = {
  neoBrands: string;
  points: number | string;
  email: string;
  mobile: any;
  panelistId: number;
  studyData: string;
  service: string;
  requestType: string;
  currency: string;
  studyID: any;
  ipAddress: string;
};

export const claimNeoRewardDetails = async (FormState: formState) => {
  const {
    neoBrands,
    points,
    email,
    mobile,
    panelistId,
    studyData,
    service,
    requestType,
    currency,
    studyID,
    ipAddress
  } = FormState;
  return securePost("/api/survey/claimLoopSurveyNeoReward", {
    neoBrands,
    points,
    email,
    mobile,
    panelistId,
    appName: "zampliasurveys",
    ...(requestType === "Study" && { studyData }),
    service,
    requestType,
    currency,
    studyID,
    ipAddress
  });
};

export const getPanelListCompletedData = async (
  panelListId: number,
  page: number,
  fromDate: any,
  type: string
) => {
  return secureGet("/api/survey/getPanelListCompletedSurveys", {
    panelListId,
    page,
    fromDate,
    type,
  });
};

export const addStudyClaimRequest = async ({ panelListId, studyId, points, p_id }) => {
  return secureGet("/api/survey/addLoopSurveyStudyClaimRequest", {
    panelListId,
    studyId,
    points,
    p_id,
  });
};

export const ResendOtpForClaim = async (type: string, id: string) => {
  return securePost("/api/survey/resendOtpForClaimLoopSurveyReward", {
    type,
    id,
    appName: "zampliasurveys",
  });
};

export const VerifyZampliaSurveys = async (
  emailOtp: number,
  smsOtp: number,
  id: number,
  panelListId: number
) => {
  return securePost("/api/survey/resendOtpForClaimLoopSurveyReward", {
    emailOtp,
    smsOtp,
    id,
    cashout: "zampliasurveys cashout",
    panelListId,
  });
};

export const verifyZampliaSurveys = async (
  emailOtp: number,
  smsOtp: number,
  id: string,
  panelListId: number,
  cashout: any,
  service: string,
  studyId: any
) => {
  return securePost("/api/survey/verifyZampliaSurveysClaimRequestOtp", {
    emailOtp,
    smsOtp,
    id,
    cashout,
    panelListId,
    service,
    studyId
  });
};

export const referralBalance = async (panelListId: number) => {
  return secureGet("/api/survey/referralWallet", { panelListId });
};

export const bonusStatusDetailsApi = async (panelListId: number) => {
  return secureGet("/api/user/bonusPointDetails", { panelListId });
};

export const AfterVerificatiobProcess = async (panelistId: number) => {
  return securePost("/api/user/updateBonusStatus", { panelistId });
};